import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Info } from 'lucide-react';

export const CalculationDialog = ({ title, explanation }) => {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button
          size="sm"
          variant="ghost"
          className="h-6 w-6 p-0 text-primary hover:text-primary-glow hover:bg-primary/10"
        >
          <Info className="w-4 h-4" />
        </Button>
      </DialogTrigger>
      <DialogContent className="bg-card border-border max-w-2xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-primary font-display text-2xl">
            {title} - Skaičiavimas
          </DialogTitle>
        </DialogHeader>
        <div className="text-foreground/90 space-y-4 leading-relaxed whitespace-pre-line">
          {explanation}
        </div>
      </DialogContent>
    </Dialog>
  );
};
